import AggregatorType from "./AggregatorType.js";

// https://docs.google.com/document/d/1DjxZU1qm8P7BjTRsQSmNxzEbSBT2Oo0nshhw561PAdc/edit#heading=h.hf6mwpc1l82p
const GeneralRankingStats = {
    // https://www.mlb.com/glossary/standard-stats/games-played
    GamesPlayed: { key: 'GamesPlayed', aggregator: AggregatorType.SUM.key, name: 'Games Played', short: 'G', type: 'NUMBER', description: 'A player is credited with having played a game if he appears in it at any point -- be it as a starter or a replacement.' },
};

export default GeneralRankingStats;